import axios from 'axios'

export default {
  /**
   * Get all active order locations (public - for dropdowns)
   */
  getAll() {
    return axios.get('/api/order-locations')
  },

  /**
   * Get all order locations (admin)
   */
  getAllAdmin() {
    return axios.get('/api/admin/order-locations')
  },

  /**
   * Get a single order location
   */
  getById(id) {
    return axios.get(`/api/admin/order-locations/${id}/show`)
  },

  /**
   * Create a new order location
   */
  create(data) {
    return axios.post('/api/admin/order-locations', data)
  },

  /**
   * Update an order location
   */
  update(id, data) {
    return axios.patch(`/api/admin/order-locations/${id}/update`, data)
  },

  /**
   * Delete an order location
   */
  delete(id) {
    return axios.delete(`/api/admin/order-locations/${id}/destroy`)
  },

  /**
   * Update sort order for order locations
   */
  updateOrder(ids) {
    return axios.post('/api/admin/order-locations/update-order', { ids })
  }
}
